import { SnackbarKey } from 'notistack';
import React from 'react';
import { CommonDataProps } from '../../utils';
import { Alert } from '../Alert';
import { AlertSeverity } from './SnackbarContent';

export interface SnackbarErrorContentProps extends CommonDataProps {
  closeSnackbar: (key: SnackbarKey) => void;
  id: SnackbarKey;
  severity: AlertSeverity;
  title: string;
  details?: string[];
  subtitle?: string;
}

export const SnackbarErrorContent = React.forwardRef<HTMLDivElement, SnackbarErrorContentProps>(
  function SnackbarErrorContent({ id, title, subtitle, details, severity, closeSnackbar, ...otherProps }, ref) {
    return (
      <Alert
        ref={ref}
        {...otherProps}
        severity={severity}
        onClose={() => closeSnackbar(id)}
        aria-describedby="snackbar-err-content"
        sx={{ minWidth: 300 }}
        Header={<div id="snackbar-err-content">{title}</div>}
        MoreDetails={
          details ? (
            <>
              {details.map((msg, idx) => (
                <div key={idx}>{msg}</div>
              ))}
            </>
          ) : undefined
        }
      >
        {subtitle}
      </Alert>
    );
  }
);
